/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { CardCarouselContainer, CardLayeredVariations, Messages } from '@marriott/mi-ui-library';
import { useApolloClient } from '@apollo/client';

import { CardCarouselResortsProps, FacetMap } from './CardCarouselResorts.types';
import { StyledContainer } from './CardResortsWrapper.styles';
import {
  IMPRESSION_TRACK,
  MERCHANDISING_CATEGORY,
  NO_OF_CARDS_TABLET,
  RESORT_CAROUSEL_ERROR_POLICY,
  IMAGE_CACHE_DOMAIN,
  CARD_SQUARE,
  CARD_HORIZONTAL,
  CARD_TALL,
  OFFER_CAUROSEL_DEFAULT_IMAGE,
} from './../../constants/ResortCardConstants';
import { CarouselUXLMockJson } from './__mock__/ResortCarouselUXL.mock';
import { phoenixResortsCarousel } from '@marriott/mi-brands-graphql';
import { SkeletonCardCarouselLoader } from './SkeletonCardCarouselLoader/index';
import { generateRandomNumber, getWCMModeFlagValue } from '@marriott/shared/mi-helper-utils';
import { useClientEnvVarsStore } from '@marriott/mi-store-utils';
import { getCtaUrl } from '@marriott/mi-brands-components/utils';

export const CardResortsWrapper: React.FC<CardCarouselResortsProps> = props => {
  const { model, acceptLanguage, isAuthorMode, requestId, subDirectoryContextPath } = props;
  const apolloClientRef = useApolloClient(); // create apollo client instance
  const [resortResult, setResultResort] = useState<any>([]);
  const [cardCount, setCardCount] = useState(0);
  const [offset, setOffset] = useState<number>(0);
  const [queryComplete, setQueryCompleted] = useState<number>(0);
  const [keys, setKeys] = useState<any>([]);
  const [totalResortCount, _setTotalResortCount] = useState({ totalCount: 0 });
  const [isLoading, setIsLoading] = useState(false);
  const acceptLang = acceptLanguage?.split(',')[0];
  const [errorMsgBlock, setErrorMsgBlock] = useState(false);
  // const openInaNewTab = model?.openInaNewTab ? JSON.parse(model.openInaNewTab) : false; // This is temp off will take up once suggested chagnes will come

  // Facet assignment based on the availability
  const searchCriteria =
    model?.searchFacets &&
    model.searchFacets.reduce((acc: any, item: any) => {
      acc[item.facettype] = item.criteria;
      return acc;
    }, {} as FacetMap);

  const { envVarsObject } = useClientEnvVarsStore();
  const cardLayeredVariation =
    model?.cardSettings?.cardsType === CARD_SQUARE
      ? CardLayeredVariations.Square
      : model?.cardSettings?.cardsType === CARD_TALL
      ? CardLayeredVariations.Tall
      : CARD_HORIZONTAL;
  const isWcmModeDisabledFlag = getWCMModeFlagValue();
  const resortKeys = '';
  const [baseRequestVariables, setBaseVariables] = useState<any>({});

  useEffect(() => {
    const filters: any = [];
    if (searchCriteria) {
      Object.keys(searchCriteria).forEach(key => {
        filters.push({
          type: key,
          dimensions: searchCriteria[key],
        });
      });
    }
    let updatedOffset;
    let offsetNumber = 0;
    if (typeof window !== 'undefined') {
      updatedOffset =
        localStorage?.getItem('filteredResortCount') != null ? localStorage.getItem('filteredResortCount') : '0';
      offsetNumber = updatedOffset != null ? parseInt(updatedOffset) : 0;
    }

    let partialRequestVariables: any = {};
    partialRequestVariables = {
      // limit: parseInt(model?.maxResortsCount),
      offset: offsetNumber, //offset,
      // version: 'V1',
      search: {
        // keyword: '*:*',
        destination: '',
        facets: {
          terms: filters,
        },
      },
    };

    if (queryComplete === 0) {
      partialRequestVariables.offset = offsetNumber;
    }

    const resortObj: any = {};
    resortObj[resortKeys] = totalResortCount.totalCount;

    if (typeof window !== 'undefined' && totalResortCount.totalCount !== 0) {
      const resortObject: any = localStorage?.getItem('resortObject');
      const parsedResortObject: any = JSON.parse(resortObject);
      const newObj = {
        ...parsedResortObject,
        ...resortObj,
      };
      localStorage.setItem('resortObject', JSON.stringify(newObj));
    }
    setBaseVariables(partialRequestVariables);
  }, []);

  useEffect(() => {
    if (Object.keys(baseRequestVariables)?.length) {
      fetchResortsData();
    }
  }, [baseRequestVariables]);

  const processDataOnComplete = (queryData: any) => {
    setQueryCompleted(1);
    setIsLoading(false);
    const mappedUxlData = processBrandsUxlData(queryData);
    InitializeBrandsCarousel(mappedUxlData);
    if (isAuthorMode && !isWcmModeDisabledFlag) {
      const mappedUxlData = processBrandsUxlData(CarouselUXLMockJson);
      InitializeBrandsCarousel(mappedUxlData);
    }
  };
  const handleOnError = () => {
    setIsLoading(true);
  };

  const fetchResortsData = async () => {
    setIsLoading(true);
    const query = phoenixResortsCarousel;
    const queryCommonContext = {
      context: {
        headers: {
          'x-request-id': requestId,
          'accept-language': acceptLang,
          ...(envVarsObject?.['NEXT_PUBLIC_UAT_AUTH_TOKEN'] &&
            isWcmModeDisabledFlag && { Authorization: envVarsObject?.['NEXT_PUBLIC_UAT_AUTH_TOKEN'] }),
        },
      },
    };
    const load = {
      variables: {
        ...baseRequestVariables,
      },
      ...queryCommonContext,
    };
    const { data, error } = await apolloClientRef.query({
      fetchPolicy: 'network-only',
      errorPolicy: RESORT_CAROUSEL_ERROR_POLICY,
      query: query,
      ...load,
    });
    if (data) {
      setIsLoading(false);
      processDataOnComplete(data);
    } else if (error) {
      handleOnError();
    }
  };

  /**
   * @description: responsibility for this function is to send cards randomly
   * @returns Number
   */
  function generateOffsetNumber(): number {
    const cardLimit = parseInt(model?.maxPropertiesCount);
    let newOffsetCount = 0;
    if (typeof window !== 'undefined' && localStorage.getItem('resortObject') != null) {
      const resortObject: any = localStorage.getItem('resortObject');
      const parsedResortObject = JSON.parse(resortObject);
      const availableResortForKey = parsedResortObject[resortKeys];
      const maxLimitOffset = availableResortForKey - cardLimit;
      if (availableResortForKey && availableResortForKey !== undefined && availableResortForKey > cardLimit) {
        newOffsetCount = Math.floor(generateRandomNumber() * (maxLimitOffset - 1 + 1)) + 1;
      }
    }
    return newOffsetCount;
  }

  useEffect(() => {
    if (typeof window !== 'undefined' && localStorage?.getItem('resortObject')?.length && totalResortCount) {
      setOffset(generateOffsetNumber());
    }
  }, [totalResortCount]);

  const processBrandsUxlData = (uxlData: any) => {
    // Initialize defaultResorts
    let defaultResorts = [];

    // Check if uxlData is defined, otherwise assign an empty array
    const response = uxlData || [];
    const offsetValue = generateOffsetNumber();
    localStorage.setItem('filteredResortCount', JSON.stringify(offsetValue));
    // Get the filtered resort count
    const filteredResortCount = response?.search?.properties?.searchByDestination?.total ?? 0;
    filteredResortCount === 0 ? setErrorMsgBlock(true) : setErrorMsgBlock(false);
    totalResortCount.totalCount = filteredResortCount;

    //localStorage.setItem('filteredResortCount', JSON.stringify(filteredResortCount));
    const resortsDataMap = response?.search?.properties?.searchByDestination?.edges ?? [];
    // eslint-disable-next-line prefer-const, prettier/prettier
    defaultResorts = resortsDataMap
      ?.filter((edge: any) => edge?.node?.basicInformation?.bookable === true)
      ?.map((item: any) => {
        // eslint-disable-next-line array-callback-return
        const cardImageNode = item?.node?.media?.primaryImage?.edges[0]?.node?.imageUrls;
        let propertyImage =
          cardLayeredVariation === CardLayeredVariations.Square
            ? cardImageNode?.square
            : cardLayeredVariation === CardLayeredVariations.Tall
            ? cardImageNode?.classicVertical
            : cardImageNode?.classicHorizontal;
        const ctaUrl = getCtaUrl(item?.node, acceptLang);
        // If propertyImage is not available, try to get it from brand photos
        if (!propertyImage && item?.node?.basicInformation?.brand?.photos?.length > 0) {
          propertyImage =
            item?.node?.basicInformation?.brand?.photos[0]?.content[0]?.url ?? OFFER_CAUROSEL_DEFAULT_IMAGE;
        }
        return {
          image: propertyImage,
          header: item?.node?.basicInformation?.name,
          propertyName: item?.node?.basicInformation?.name,
          ctaUrl: ctaUrl,
          newProperty: item?.node?.basicInformation?.newProperty,
          isFullyRenovated: item?.node?.basicInformation?.isFullyRenovated,
          isRecentlyRenovated: item?.node?.basicInformation?.isRecentlyRenovated,
          isAdultsOnly: item?.node?.basicInformation?.isAdultsOnly,
          hasRenovatedRooms: item?.node?.basicInformation?.hasRenovatedRooms,
          country: item?.node?.contactInformation?.address?.country?.description, //mapping with description as label is coming null in data
        };
      });
    defaultResorts = defaultResorts.filter((cards: any) => cards.image !== null);
    return { resortsData: shuffleResorts(defaultResorts) };
  };

  function shuffleResorts<T>(defaultResorts: T[]): T[] {
    const shuffledResort = defaultResorts ? [...defaultResorts] : [];
    for (let i = shuffledResort.length - 1; i > 0; i--) {
      const j = Math.floor(generateRandomNumber() * (i + 1));
      [shuffledResort[i], shuffledResort[j]] = [shuffledResort[j], shuffledResort[i]];
    }
    return shuffledResort;
  }

  const InitializeBrandsCarousel = (data: any) => {
    const count = data?.resortsData?.length;
    const cardKeys = Object?.keys(data?.resortsData);
    setCardCount(count);
    setKeys(cardKeys);
    const resortMap = data?.resortsData?.map((card: any, index: number) => {
      let imageUri = '';
      let imageUriLg = '';
      if (card?.image) {
        if (card?.image?.includes('/is/image')) {
          imageUri = !isAuthorMode ? `${card?.image}?wid=364&fit=constrain` : `${card?.image}`;
          imageUriLg = !isAuthorMode ? `${card?.image}?wid=800&fit=constrain` : `${card?.image}`;
        } else if (card?.image?.includes('marriottassets') || card?.image?.includes('/content/dam')) {
          imageUri = `${card.image}?downsize=365px:*`;
          imageUriLg = `${card.image}?downsize=800px:*`;
        }
        if (!imageUri.startsWith(IMAGE_CACHE_DOMAIN)) {
          imageUri = IMAGE_CACHE_DOMAIN + imageUri;
          imageUriLg = IMAGE_CACHE_DOMAIN + imageUriLg;
        }
      }
      const cardLocDetails = model?.trackingProperties?.location
        ? `${model.trackingProperties.location}-card-${index}`
        : `card-${index}`;
      const eyeBrowText = card?.country;
      const badgeText =
        card?.newProperty === true
          ? model?.newHotelLabel
          : card?.isFullyRenovated === true
          ? model?.fullyRenovatedLabel
          : card?.isRecentlyRenovated === true
          ? model?.recentlyRenovatedLabel
          : card?.isAdultsOnly === true
          ? model?.adultsOnlyLabel
          : card?.hasRenovatedRooms === true
          ? model?.renovatedRoomsLabel
          : null;

      return {
        ':items': {
          [`card-carousel-${index}`]: {
            trackingProperties: {
              atCCeVar48: null,
              additionalTrackingVariables: null,
              trackingDescription: card?.header,
              description: card?.header,
              clickTrack: model?.trackingProperties?.clickTrack ? true : false,
              impressionTrack: false,
              location: cardLocDetails,
              trackingContentPosition: cardLocDetails,
              merchandisingCategory: 'nonCobrand',
              impressionCount: false,
              trackingTag: model?.trackingProperties?.trackingTag,
              trackingResortType: null,
              cardLocation: model?.trackingProperties?.cardLocation,
              leftArrowDesc: model?.trackingProperties?.leftArrowDesc,
              rightArrowDesc: model?.trackingProperties?.rightArrowDesc,
            },
            eyebrow: eyeBrowText,
            styleclass: model?.cardSettings?.cardTheme,
            headerTag: 'h3',
            icon: '',
            impressionTrack: IMPRESSION_TRACK,
            cardLayeredVariations: cardLayeredVariation,
            badgeIcon: '',
            imgAltText: card?.header,
            clickTrack: model?.trackingProperties?.clickTrack ? true : false,
            fileReferenceImage: imageUriLg,
            header: card.header,
            fontSize: 't-subtitle-l',
            ':type': 'mi-aem-common-spa/components/content/cardlayered',
            [`${cardLayeredVariation === CardLayeredVariations.Square ? 'dynamicMedia' : 'dynamicMediaTall'}`]: {
              altText: card?.header,
              assetPath: imageUriLg,
              dynamic: true,
              renditions: [
                {
                  renditionPath: imageUriLg,
                  mediaValue: '768px',
                  width: 0,
                  dynamic: true,
                  damPath: imageUriLg,
                  mediaQuery: 'min-width',
                  height: 0,
                },
                {
                  renditionPath: imageUri,
                  mediaValue: '576px',
                  width: 0,
                  dynamic: true,
                  damPath: imageUri,
                  mediaQuery: 'min-width',
                  height: 0,
                },
                {
                  renditionPath: imageUri,
                  mediaValue: '576px',
                  width: 0,
                  dynamic: true,
                  damPath: imageUri,
                  mediaQuery: 'max-width',
                  height: 0,
                },
              ],
              damPath: card?.image,
            },
            merchandisingCategory: MERCHANDISING_CATEGORY,
            impressionCount: IMPRESSION_TRACK,
            ctaLink: card?.ctaUrl,
            badgeText: badgeText,
            openInNewTab: true,
          },
        },
      };
    });
    const maxItemSendtoUI = resortMap.splice(0, model?.maxPropertiesCount);
    setResultResort(maxItemSendtoUI);
  };

  const allowedComponents = [
    {
      path: '/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/cardlayered',
      title: 'Card Layered',
    },
  ];
  const trackingProperties = {
    trackingContentPosition: '',
    trackingOfferType: '',
    atCCeVar48: '',
    trackingDescription: '',
    trackingTag: 'trackingTag',
    isCoBrand: false,
    clickTrack: false,
    impressionTrack: true,
    impressionCount: true,
    impressionEventType: '',
    merchandisingCategory: '',
    additionalTrackingVariables: '',
    location: '',
    payloadType: '',
    compName: '',
    enableScrollingBehavior: false,
    cardLocation: '',
    leftArrowDesc: '',
    rightArrowDesc: '',
    description: '',
  };

  return (
    <StyledContainer>
      <div>
        {!isLoading ? (
          <div>
            {errorMsgBlock && (
              <div className={clsx('text-left')}>
                <Messages messageType={'info'} messageHeading={model?.errorMsg} />
              </div>
            )}
            <div
              className={clsx(cardCount > 0 ? '' : 'hideCarousel', 'container card-wrapper-brands')}
              data-testid="card-carousel-resorts"
            >
              {resortResult && resortResult?.length > 0 && (
                <CardCarouselContainer
                  headerText={model?.titleText}
                  subHeaderText={model?.subTitleText}
                  noOfCards={model?.cardSettings?.noOfCards}
                  ctaLabel={model?.ctaLabel}
                  ctaLink={model?.ctaLink}
                  ctaType={model?.ctaType}
                  cardCount={resortResult?.length}
                  openInaNewTab={false}
                  totalNumberOfCards={keys}
                  trackingProperties={trackingProperties}
                  styleclass={model?.styleclass}
                  cqItems={resortResult}
                  componentId={model?.componentId}
                  pagePath={''}
                  itemPath={''}
                  wcmMode={model?.wcmMode}
                  isAuthorMode={isAuthorMode}
                  noOfCardsTablet={NO_OF_CARDS_TABLET}
                  allowedComponents={allowedComponents}
                  variation={model?.variation}
                  isControlType2={model?.styleclass?.includes('phoenix-brands') && true}
                  previousLabel={model?.previousLabel}
                  nextLabel={model?.nextLabel}
                  rightArrowAriaLabel={model?.rightArrowAriaLabel}
                  leftArrowAriaLabel={model?.leftArrowAriaLabel}
                />
              )}
            </div>
          </div>
        ) : (
          <div>
            <SkeletonCardCarouselLoader cardType={cardLayeredVariation} />
          </div>
        )}
      </div>
    </StyledContainer>
  );
};
export default CardResortsWrapper;
